__turbopack_context__.v({
  "breadcrumb": "lQZXKa_breadcrumb",
  "counter": "lQZXKa_counter",
  "crumbCurrent": "lQZXKa_crumbCurrent",
  "crumbItem": "lQZXKa_crumbItem",
  "crumbLink": "lQZXKa_crumbLink",
  "crumbList": "lQZXKa_crumbList",
  "crumbSep": "lQZXKa_crumbSep",
  "heading": "lQZXKa_heading",
  "headingRow": "lQZXKa_headingRow",
});
